import { eventBus as EventBus } from "@/utils/eventBus";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig";
import { hasAccess, openLoginModal } from "@/utils/tokenCheck";

export const HEERA_NOTIFS = {
  scanResume: {
    name: "Scan",
    message: "Not sure if your resume is job ready? Let me analyze and improve it.",
    cta: "Scan My Resume",
    action: "scanResume",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  },
  createProfile: {
    name: "Create Profile",
    message: "Stop waiting for opportunities. Create your professional profile and get noticed.",
    cta: null,
    action: "createProfile",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  },
  exploreCourses: {
    name: "Courses",
    message: "Explore our industry-recognized courses to stay ahead and boost your career growth.",
    cta: null,
    action: "exploreCourses",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  },
  takeAssessment: {
    name: "Assessments",
    message: "Measure your strengths and readiness with our custom assessments.",
    cta: null,
    action: "takeAssessment",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  },
  practiceInterviews: {
    name: "Mock Interview",
    message: "Boost your interview confidence with mock interviews tailored to your target roles.",
    cta: null,
    action: "practiceInterviews",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  },
  exploreJobs: {
    name: "Jobs",
    message: "Discover top job opportunities tailored to your professional profile.",
    cta: null,
    action: "exploreJobs",
    avatar: require("@/assets/guestHeader/heera-icon.webp")
  }
};

export default {
  data() {
    return {
      notifications: [],
      notifOpen: false,
    };
  },
  mounted() {
    this.onSetNotifOpen = (val) => {
      this.notifOpen = val;
    };
    EventBus.$on("set-notif-open", this.onSetNotifOpen);
  },
  beforeDestroy() {
    EventBus.$off("set-notif-open", this.onSetNotifOpen);
  },
  watch: {
    notifOpen(val) {
      if (val) {
        this.loadNotifications();
      }
      if (val || this.searchActive || this.isMobileMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      EventBus.$emit("set-notif-open", val);
    },
  },
  methods: {
    dismissNotif(index) {
      const removed = this.notifications[index];
      this.notifications.splice(index, 1);
      if (removed && removed.action) {
        try {
          let active = ["scanResume"];
          let cookieValue = null;
          if (typeof document !== "undefined" && document.cookie) {
            const match = document.cookie.match(/(^|;)\s*hire3x_heera_notifications\s*=\s*([^;]+)/);
            if (match) cookieValue = match[2];
          }
          if (cookieValue) {
            active = JSON.parse(decodeURIComponent(cookieValue));
          } else {
            const stored = sessionStorage.getItem("hire3x_heera_notifications");
            if (stored) active = JSON.parse(stored);
          }
          
          active = active.filter(a => a !== removed.action);
          sessionStorage.setItem("hire3x_heera_notifications", JSON.stringify(active));
          document.cookie = `hire3x_heera_notifications=${encodeURIComponent(JSON.stringify(active))}; ${COOKIE_OPTIONS_SUFFIX}`;
        } catch (e) {
          console.error(e);
        }
      }
    },
    loadNotifications() {
      const order = ["scanResume", "createProfile", "exploreCourses", "takeAssessment", "practiceInterviews", "exploreJobs"];
      let active = ["scanResume"];
      const isMobile = typeof window !== "undefined" && window.innerWidth <= 1028;

      if (isMobile) {
        active = [...order];
      } else {
        try {
          let cookieValue = null;
          if (typeof document !== "undefined" && document.cookie) {
            const match = document.cookie.match(/(^|;)\s*hire3x_heera_notifications\s*=\s*([^;]+)/);
            if (match) cookieValue = match[2];
          }
          if (cookieValue) {
            active = JSON.parse(decodeURIComponent(cookieValue));
          } else {
            const stored = sessionStorage.getItem("hire3x_heera_notifications");
            if (stored) {
              active = JSON.parse(stored);
            } else {
              sessionStorage.setItem("hire3x_heera_notifications", JSON.stringify(active));
              document.cookie = `hire3x_heera_notifications=${encodeURIComponent(JSON.stringify(active))}; ${COOKIE_OPTIONS_SUFFIX}`;
            }
          }
        } catch (e) {
          console.error(e);
        }
      }

      this.notifications = order
        .filter(action => active.includes(action))
        .map(action => HEERA_NOTIFS[action]);
    },
    handleNotifAction(notif) {
      this.notifOpen = false;
      const conf = this.config || this;
      if (notif.action === "scanResume") {
        if (typeof this.showResumeClinicModal === "function") {
          this.showResumeClinicModal();
        } else if (typeof this.openResumeClinicModal === "function") {
          this.openResumeClinicModal();
        } else if (typeof this.handleOpenResumeClinic === "function") {
          this.handleOpenResumeClinic();
        } else {
          EventBus.$emit("resume-clinic-opened");
        }
      } else if (notif.action === "createProfile") {
        const redirectUrl = `${conf.candidateBase}/dashboard?from=candidate`;
        if (hasAccess()) {
          window.location.href = redirectUrl;
        } else {
          openLoginModal({ mode: "register", redirectUrl });
        }
      } else if (notif.action === "exploreCourses") {
        window.location.href = `${conf.trainingBase}/marketplace`;
      } else if (notif.action === "takeAssessment") {
        window.location.href = `${conf.candidateBase}/assessment/marketplace?from=candidate`;
      } else if (notif.action === "practiceInterviews") {
        if (typeof this.openCandidateLoginModal === "function") {
          this.openCandidateLoginModal();
        } else {
          openLoginModal({
            redirectUrl: `${conf.candidateBase}/interview?from=candidate`,
          });
        }
      } else if (notif.action === "exploreJobs") {
        window.location.href = `${conf.candidateBase}/job/search?from=candidate`;
      }
    },
  }
};
